import React from 'react'
import { Isologo } from '@/shared/components/Isologo'
import { Box, HStack, Text } from '@chakra-ui/react'
import { NucArrowLeft } from '@nucba-coding/nucba-ui'
import { useLocation, useNavigate } from 'react-router-dom'

export const Navbar = () => {
  const navigate = useNavigate()

  const location = useLocation()
  const isHelpCenterRoot = location.pathname === '/help-center'

  return (
    <HStack
      display={'flex'}
      alignItems={'center'}
      maxWidth={'1920px'}
      height={{ md: '120px', xl: '160px' }}
    >
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        width={'100%'}
        pr={'30px'}
      >
        <HStack
          gap={2}
          align='center'
          _hover={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => navigate(-1)}
        >
          {!isHelpCenterRoot && (
            <>
              <NucArrowLeft />
              <Text>Volver atrás</Text>
            </>
          )}
        </HStack>

        <Isologo />
      </Box>
    </HStack>
  )
}
